'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import { XALOLEAD_ENDPOINT, SEND_MAIL_ENDPOINT } from './const.js';

function getXaloLead(baseMsUrl, langCode) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var response, resData, xaloleadInfo, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(XALOLEAD_ENDPOINT), {
                            method: 'GET',
                            headers: {
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    resData = _c.sent();
                    if ((_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.attributes) {
                        xaloleadInfo = (_b = resData === null || resData === void 0 ? void 0 : resData.data) === null || _b === void 0 ? void 0 : _b.attributes;
                        return [2 /*return*/, xaloleadInfo];
                    }
                    return [2 /*return*/];
                case 3:
                    err_1 = _c.sent();
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function sendMailXaloLead(baseMsUrl, langCode, data) {
    return __awaiter(this, void 0, void 0, function () {
        var formData, _i, _a, _b, key, value, response, resData, err_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    for (_i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
                        _b = _a[_i], key = _b[0], value = _b[1];
                        if (value) {
                            formData.append(key, value);
                        }
                    }
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(SEND_MAIL_ENDPOINT), {
                            method: 'POST',
                            headers: {
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    resData = _c.sent();
                    if ((resData === null || resData === void 0 ? void 0 : resData.status) === 'SUCCESS') {
                        return [2 /*return*/, resData];
                    }
                    return [2 /*return*/];
                case 3:
                    err_2 = _c.sent();
                    console.error(err_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { getXaloLead, sendMailXaloLead };
//# sourceMappingURL=index.js.map
